(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5204],{

/***/ 55204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content045": function() { return /* binding */ Content045; },
  "default": function() { return /* binding */ Content045_Content045; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/widgets/content/Content045/Content045.module.scss
var Content045_module = __webpack_require__(76921);
var Content045_module_default = /*#__PURE__*/__webpack_require__.n(Content045_module);
// EXTERNAL MODULE: ./src/components/widgets/content/Content045/Item/Item.module.scss
var Item_module = __webpack_require__(37009);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content045/Item/Item.jsx



var Item = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Item_module_default()).items,
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Item_module_default()).item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "blue",
                        uppercase: true,
                        className: (Item_module_default()).date,
                        children: item.dateTo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "grey",
                        appearance: "bold",
                        className: (Item_module_default()).price,
                        children: item.price
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "dark",
                        className: (Item_module_default()).additional,
                        children: item.additionalPriceNotes
                    })
                ]
            }, item.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content045/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content045/Content045.jsx






var Content045 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var note = (ref2 = payload === null || payload === void 0 ? void 0 : payload.note) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var blocks = (ref3 = payload === null || payload === void 0 ? void 0 : payload.blocks) !== null && ref3 !== void 0 ? ref3 : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content045_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content045_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Content045_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                                className: (Content045_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Content045_module_default()).text,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                        value: description,
                                        className: (Content045_module_default()).description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                                        viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                            color: "grey",
                                            className: (Content045_module_default()).note,
                                            children: note
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        items: blocks
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                        viewMode: ViewMode/* VIEW_MODES.MOBILE */.nY.MOBILE,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            color: "grey",
                            className: (Content045_module_default()).note,
                            children: note
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Content045_Content045 = (Content045);


/***/ }),

/***/ 76921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content045_wrapper__06wHx","block":"Content045_block__qIVf1","content":"Content045_content__EQXND","text":"Content045_text__4pZv1","title":"Content045_title__uL2ax","description":"Content045_description__8tA3r","note":"Content045_note__m2iz8"};

/***/ }),

/***/ 37009:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"items":"Item_items__PFYqw","item":"Item_item__VWp7B","date":"Item_date__1DQnP","price":"Item_price__wfa44","additional":"Item_additional__HpxfC"};

/***/ })

}]);